import { safeGradient } from "@/shared/utils/gradient-css";
import { isGradient } from "@components/color-picker/lib/detect";
import styled, { css } from "styled-components";
import type { SlideBackgroundStyledProps } from "../types";

const safeBackground = (value: string | undefined): string => {
  if (!value) return "transparent";
  if (isGradient(value)) return safeGradient(value) ?? "transparent";
  return value;
};

export const SlideBackgroundStyled = styled.div<SlideBackgroundStyledProps>`
  ${({
    $backgroundColor,
    $overlayOpacity,
    $blackAndWhiteFilter,
    $hasBackground,
  }) => css`
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: ${safeBackground($backgroundColor)} !important;
      opacity: ${!$hasBackground
        ? 1
        : $overlayOpacity
          ? Number($overlayOpacity) / 100
          : 0};
    }
    ${$blackAndWhiteFilter &&
    css`
      img,
      video {
        filter: grayscale(100%);
      }
    `}
  `}
`;
